// React
import React from 'react';

// Components

const HeaderImageComponent = ({ initiative }) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const isAllowedUrl = url =>
        url?.startsWith(
            'https://foundgood-initiative-update-content-media.s3.eu-west-1.amazonaws.com/'
        );

    // ///////////////////
    // RENDER
    // ///////////////////

    return initiative?.Hero_Image_URL__c &&
        isAllowedUrl(initiative?.Hero_Image_URL__c) ? (
        <div className="h-[400px] w-full">
            <img
                className="w-full z-below h-[400px] object-cover"
                src={initiative?.Hero_Image_URL__c}
            />
        </div>
    ) : null;
};

HeaderImageComponent.propTypes = {};

HeaderImageComponent.defaultProps = {};

export default HeaderImageComponent;
